var o={videoContainer:"video-module_videoContainer__dpoF4",videoControls:"video-module_videoControls__Ylj1I",controlLeft:"video-module_controlLeft__YeLbC",themeDark:"video-module_themeDark__TMqE7"};export{o as default};
